import Tooltip from 'components/tooltips/Tooltip'
import Icon from 'components/elements/Icon'

import { Legality as LegalityType } from 'services/apiTypes/card.types'

import styles from './legalityKey.module.scss'

export const LEGALITY_COLORS: Record<LegalityType, string> = {
  legal: '#3d8f52',
  banned: '#783131',
  restricted: '#999049',
  not_legal: '#6b6b6b',
}

const LegalityKey = () => (
  <Tooltip trigger={<Icon name="question" />} className={styles.container}>
    <label className={styles.label} style={{ backgroundColor: LEGALITY_COLORS.legal }}>
      Legal
    </label>
    <label className={styles.label} style={{ backgroundColor: LEGALITY_COLORS.restricted }}>
      Restricted
    </label>
    <label className={styles.label} style={{ backgroundColor: LEGALITY_COLORS.banned }}>
      Banned
    </label>
    <label className={styles.label} style={{ backgroundColor: LEGALITY_COLORS.not_legal }}>
      Not Legal
    </label>
  </Tooltip>
)

export default LegalityKey
